import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import cx from 'clsx';

import { type NestingInstruction } from '@editor2/types/pageElements';

import { nestingInstruction } from './styles';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { elementCommonStyles } from '@editor2/styles/element';

interface Props {
	element: NestingInstruction;
	courseId: number;
}

const NestingInstructionElement: FC<Props> = (props) => {
	const { element, courseId } = props;

	const commonPayload = { elementId: element.family_id, courseId };

	const dispatch = useDispatch();

	const CONTAINER_CLASS_OPTIONS = [
		'learning-objective',
		'webtext-callout',
		'webtext-example',
		'unstyled',
		'webtext-pull-quote',
		'marker-icon',
		'global',
		'hands-and-globe',
		'brain-head',
		'spreadsheet',
		'chat-bubbles',
		'document',
		'scales-of-justice',
		'webtext-primary-source',
		'beginning-without-ending',
		'continuation-without-ending',
		'continuation-with-ending',
		'beginning-with-ending'
	];

	const onClassCheck = (value) => {
		const index = element.container_classes.indexOf(value);

		const containerClasses =
			index === -1
				? [...element.container_classes, value]
				: [
						...element.container_classes.slice(0, index),
						...element.container_classes.slice(index + 1)
				  ];

		dispatch(
			updateElement({
				...commonPayload,
				container_classes: containerClasses
			})
		);
	};

	return (
		<Form className={cx(nestingInstruction, elementCommonStyles)}>
			{element.direction === 'in' && (
				<Form.Group>
					<Form.Label>Container classes</Form.Label>
					<div className="containerClasses">
						{CONTAINER_CLASS_OPTIONS.map((option, index) => (
							<Form.Check
								type="checkbox"
								key={option}
								checked={element.container_classes.includes(option)}
								onChange={() => onClassCheck(option)}
								label={option}
							/>
						))}
					</div>
				</Form.Group>
			)}
		</Form>
	);
};

export default NestingInstructionElement;
